import { Box } from "@bcc-ui/ui-components";
import React from "react";

import { Archived } from "components/icons/Archived";
import { CollapsedFolder } from "components/icons/CollapsedFolder";
import { ExpandedFolder } from "components/icons/ExpandedFolder";
import { Folder } from "components/icons/Folder";
import { ASSET_VIEWS_ROUTE } from "components/router/Routes";
import { AssetCustomView } from "domain/asset-management/assets";

export const getFolderIcon = (
    isEmptyFolder: boolean | undefined,
    isArchiveFolder: boolean | undefined,
    isFolderExpanded: boolean
) => {
    const iconColor = "var(--app-subNavigationPanel-iconColor)";
    const iconFill = "var(--app-subNavigationPanel-iconFillColor)";

    switch (true) {
        case isArchiveFolder && isEmptyFolder:
            return (
                <Box marginLeft="Md">
                    <Archived size={20} color={iconColor} fill={iconFill} />
                </Box>
            );
        case isArchiveFolder && !isEmptyFolder:
            return <Archived size={20} color={iconColor} fill={iconFill} />;
        case isEmptyFolder:
            return (
                <Box marginLeft="Md">
                    <Folder size={20} color={iconColor} fill={iconFill} />
                </Box>
            );
        case isFolderExpanded:
            return <ExpandedFolder size={20} color={iconColor} fill={iconFill} />;
        default:
            return <CollapsedFolder size={20} color={iconColor} fill={iconFill} />;
    }
};

export const findActiveFolder = (pathname: string) =>
    ASSET_VIEWS_ROUTE.childRoutes.find(
        (route) => route.canHaveChildren && route.childRoutes.some((nestedRoute) => nestedRoute.path === pathname)
    );

export const findViewByUuid = (views: AssetCustomView[], uuid: string): AssetCustomView | undefined => {
    for (const view of views) {
        if (view.uuid === uuid) {
            return view;
        }

        const found = findViewByUuid(view.childrenViews, uuid);

        if (found !== undefined) {
            return found;
        }
    }
    return undefined;
};
